import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Analyzer } from 'types';

export const deleteAnalyzer = (analyzerId: number) => {
  return axios.delete(`/api/analyzers/${analyzerId}`);
};

type UseDeleteAnalyzerOptions = {
  config?: MutationConfig<typeof deleteAnalyzer>;
};

export const useDeleteAnalyzer = ({
  config,
}: UseDeleteAnalyzerOptions = {}) => {
  return useMutation({
    onMutate: async (deletedAnalyzerId: number) => {
      await queryClient.cancelQueries(['analyzers']);

      const previousAnalyzers = queryClient.getQueryData<Analyzer[]>([
        'analyzers',
      ]);

      queryClient.setQueryData(
        ['analyzers'],
        previousAnalyzers?.filter(
          (analyzer) => analyzer.id !== deletedAnalyzerId
        )
      );
      queryClient.setQueryData(['analyzer', deletedAnalyzerId], null);

      return previousAnalyzers;
    },
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzers) {
        queryClient.setQueryData(['analyzers'], context.previousAnalyzers);
      }
    },
    onSuccess: (result) => {
      queryClient.invalidateQueries(['analyzers']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteAnalyzer,
  });
};
